<template>
  <div>
    <v-dialog @keydown.esc="isOpen=false" v-model="isOpen" persistent max-width="400px">
      <v-card>
        <v-card-title>
          <span class="headline" v-if="subRecipe">
            Descargar reporte de subrecetas
          </span>
          <span class="headline" v-else>
            Descargar reporte de recetas
          </span>
        </v-card-title>
        <v-card-text>
          <v-form>
            <v-row>
              <v-col cols="12">
                <div>
                  Usa esta opción para que el reporte se genere con tus preferencias.
                </div>
                <div>
                  <v-radio-group v-model="csv">
                    <template v-slot:label>
                      <div class="radioTitle">¿Quieres el archivo en formato .CSV o .TXT?</div>
                    </template>
                    <v-radio
                      label="CSV"
                      value=true
                      class="ml-6 radio"
                      color="primary"
                      off-icon="mdi-circle"
                      on-icon="mdi-record-circle"
                    ></v-radio>
                    <v-radio
                      label=".TXT"
                      value=false
                      class="ml-6 radio"
                      color="primary"
                      off-icon="mdi-circle"
                      on-icon="mdi-record-circle"
                    ></v-radio>
                </v-radio-group>
                  <v-radio-group v-model="flag">
                    <template v-slot:label>
                      <div class="radioTitle">¿Requieres el reporte con ingredientes?</div>
                    </template>
                    <v-radio
                      label="Sí"
                      value=true
                      class="ml-6 radio"
                      color="primary"
                      off-icon="mdi-circle"
                      on-icon="mdi-record-circle"
                    ></v-radio>
                    <v-radio
                      label="No"
                      value=false
                      class="ml-6 radio"
                      color="primary"
                      off-icon="mdi-circle"
                      on-icon="mdi-record-circle"
                    ></v-radio>
                </v-radio-group>
                </div>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            class="mr-4"
            outlined
            rounded
            small
            depressed
            @click="close">
            Cerrar
          </v-btn>
          <v-btn
            color="primary"
            class="mr-4"
            rounded
            small
            depressed
            :href="exportRoute"
            target="_blank">
            Descargar CSV
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-overlay :value="overlay" z-index="99999">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
export default {
  props: {
    subRecipe: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isOpen: false,
      overlay: false,
      flag: null,
      csv: null
    }
  },
  computed: {
    areaId () {
      return this.$store.state.area._id
    },
    exportRoute () {
      let url = `${process.env.VUE_APP_API_URL}/v1/recipes/export/csv`
      url += `?access_token=${this.$store.state.login.token}`
      url += `&restaurant=${this.$store.state.currentRestaurant.data._id}`
      url += `&area=${this.areaId}`
      url += `&ingredients=${this.flag}`
      url += `&csv=${this.csv}`
      url += `&subrecipe=${this.subRecipe}`
      if (this.sectionSelected) url += `section&=${this.sectionSelected}`
      return url
    }
  },
  methods: {
    open () {
      this.isOpen = true
    },
    close () {
      this.isOpen = false
      this.resetDate()
    },
    async resetDate () {
      this.dates = []
    }
  }
}
</script>
